import React, { useState } from "react";
import { useParams } from "react-router-dom";
import {
  Content,
  PageTitle,
  PanelColumn,
  PageHeadingArea,
  PanelColumnSet,
} from "@backslashbuild/pp-ui";

import ContractorProductPageTitle from "../modules/contractors/ContractorProductPageTitle";
import ContractorProductDetailsPanel from "../modules/contractors/ContractorProductDetailsPanel";

export default function ContractorBranch() {
  const { contractorProductId } = useParams();

  return (
    <Content scrollable>
      <PageHeadingArea>
        <ContractorProductPageTitle contractorProductId={contractorProductId} />
      </PageHeadingArea>

      <PanelColumnSet>
        <PanelColumn>
          <ContractorProductDetailsPanel id={contractorProductId} />
        </PanelColumn>
      </PanelColumnSet>
    </Content>
  );
}
